import React from 'react';
import SkillCardProps from '../types/SkillcardProps';

const SkillCard: React.FC<SkillCardProps> = ({ category }) => {
  return (
    <div
      className="
        group relative min-h-[220px] overflow-hidden rounded-2xl
        border border-white/25 bg-[#b8c08a]/80 p-6 backdrop-blur-sm
        shadow-[0_10px_30px_rgba(0,0,0,0.18)]
        transition-all duration-500 ease-out
        hover:-translate-y-2
        hover:shadow-[0_20px_45px_rgba(0,0,0,0.30),0_0_30px_rgba(255,242,191,0.18)]
        hover:border-[#fff2bf]/60
      "
    >

      {/* soft background glow on hover */}
      <div
        className="
          pointer-events-none absolute inset-0 opacity-0
          transition-opacity duration-500
          group-hover:opacity-100
          bg-[radial-gradient(circle_at_top_left,rgba(255,255,255,0.22),transparent_35%),radial-gradient(circle_at_bottom_right,rgba(255,242,191,0.18),transparent_35%)]
        "
      />

      {/* shiny sweep effect */}
      <div
        className="
          pointer-events-none absolute inset-y-0 -left-1/3 w-1/3
          rotate-12 bg-white/20 blur-xl opacity-0
          transition-all duration-700
          group-hover:left-[120%] group-hover:opacity-100
        "
      />

      <div className="relative z-10">
        <div className="flex items-center gap-3">
          <div className="text-white transition-transform duration-300 group-hover:scale-110">
            {category.icon}
          </div>
          <h2 className="text-2xl font-semibold tracking-tight text-white">
            {category.title}
          </h2>
        </div>

        <div className="mt-5 border-t border-white/25 pt-5" />

        <div className="flex flex-wrap gap-3">
          {category.skills.map((skill) => (
            <span
              key={skill}
              className="
                rounded-xl border border-black/10 bg-[#9da45f]
                px-4 py-2 text-[1.05rem] text-white
                shadow-[0_4px_10px_rgba(0,0,0,0.16)]
                transition-all duration-300
                group-hover:bg-[#aab36a]
              "
            >
              {skill}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};
export default SkillCard;